<script setup>
import toStrapiLocale from "~/helpers/toStrapiLocale";
const props = defineProps({
  coin: {
    type: Object,
    default: {},
  },
});

const route = useRoute()
const { locale } = useI18n();
const { $get } = useAxios();
const isActiveTab = ref("description");

const { data: offices } = await useAsyncData(`get all offices`, () =>
  $get(
    `/offices?_sort=published_at:desc&_locale=${toStrapiLocale(locale.value)}`
  )
);

const { data: coinsInOffices } = await useAsyncData(`get coin in offices - ${route.params.id}`, () =>
  $get(
    `/coins-in-offices?coin_eq=${route.params.id}&_sort=published_at:desc&_locale=${toStrapiLocale(locale.value)}`
  )
);
</script>

<template>
  <div class="container">
    <div
      class="w-full md:border md:pt-5 md:pb-10 md:px-8 border-[#E1E1E1] rounded-[20px]"
    >
      <div
        class="px-4 xl:px-0 hidden md:flex mb-4 font-sans flex-row space-x-10"
      >
        <button
          @click="isActiveTab = 'description'"
          class="text-xl pb-2 focus:outline-none"
          :class="[
            isActiveTab == 'description'
              ? ' text-[#333333] border-b-[3px] border-[#FCC900]'
              : ' text-[#6F6F6F]',
          ]"
        >
          Описание
        </button>
        <button
          @click="isActiveTab = 'place'"
          class="text-xl pb-2 focus:outline-none"
          :class="[
            isActiveTab == 'place'
              ? 'text-[#333333]  border-b-[3px] border-[#FCC900]'
              : 'text-[#6F6F6F] ',
          ]"
        >
          Где забрать?
        </button>
      </div>
      <div class="bg-[#F3F3F7] h-11 mb-5 w-full grid md:hidden grid-cols-2">
        <button
          @click="isActiveTab = 'description'"
          class="text-lg min-w-40 col-span-1 font-firasans text-center h-11 focus:outline-none"
          :class="[
            isActiveTab == 'description'
              ? ' text-[#333333] bg-[#FCC900] rounded-r-[10px] font-medium'
              : ' text-[#5E5E5E] bg-#F3F3F7',
          ]"
        >
          Описание
        </button>
        <button
          @click="isActiveTab = 'place'"
          class="text-lg min-w-40 col-span-1 font-firasans text-center h-11 focus:outline-none"
          :class="[
            isActiveTab == 'place'
              ? 'text-[#333333] rounded-l-[10px] bg-[#FCC900] font-medium'
              : 'text-[#5E5E5E] bg-#F3F3F7',
          ]"
        >
          Где забрать?
        </button>
      </div>
      <a-coin-description-info
        class="px-4 xl:px-0"
        v-if="isActiveTab === 'description'"
        :coin="coin"
      ></a-coin-description-info>
      <a-coin-description-offices
        class="px-4 xl:px-0"
        :offices="offices"
        :coinsInOffices="coinsInOffices"
        v-else
      ></a-coin-description-offices>
    </div>
  </div>
</template>
